














import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';
import { BannerAspectRatioSize } from '@shared/types/BannerAspectRatio';
import { Image } from '@shared/types/Image';
import { ILink } from '@shared/types/storyblok';
import { BaseBanner, BaseLink } from '@shared/ui';

export default defineComponent({
  name: 'HeroBanner',
  components: {
    BaseLink,
    BaseBanner,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    size: {
      type: String as PropType<BannerAspectRatioSize>,
      default: 'medium',
    },
    link: {
      type: Object as PropType<ILink>,
      default: () => ({}),
    },
    bannerImage: {
      type: Object as PropType<Image>,
      required: true,
    },
    bannerImageMobile: {
      type: Object as PropType<Image>,
      default: null,
    },
  },
  setup(props) {
    const component = props.link?.cached_url ? 'BaseLink' : 'div';
    const sanitizedLink = computed(() => sanitizeLinkUrl(props.link?.cached_url));

    return {
      component,
      sanitizedLink,
    };
  },
});
